import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { FinnairThemeService } from '@fcom/common';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

@Component({
  selector: 'fin-greeting-card',
  templateUrl: './greeting-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GreetingCardComponent {
  private themeService = inject(FinnairThemeService);

  firstName = input<string>();

  isMultiPax = input(false);

  private isNewBrand = computed(() => {
    return this.themeService.siteTheme() !== FinnairTheme.LEGACY;
  });

  textKey = computed(() => {
    return this.isNewBrand() && this.isMultiPax()
      ? 'loginPromotion.greeting.text.inPaxDetailsMulti'
      : 'loginPromotion.greeting.text.inPaxDetails';
  });
}
